export function randomizeArray(): number {
  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  return Math.random() - 0.5;
}
